import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';
import { getColor } from 'ui/icons/utils';

export const EmptyStateGoals = ({
  height = 125,
  width = 125,
  color = colors.grey5,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 120 77" fill="none" {...props}>
    <path
      d="M110.88 55.1942C110.881 47.5528 109.172 40.0081 105.877 33.1134C102.583 26.2187 97.787 20.1488 91.8412 15.349C85.8954 10.5491 78.9507 7.14098 71.5162 5.37454C64.0818 3.60809 56.3463 3.52813 48.8769 5.14052C41.4076 6.7529 34.3939 10.0167 28.3501 14.6927C22.3064 19.3686 17.386 25.338 13.9496 32.1632C10.5133 38.9883 8.64826 46.4961 8.49128 54.1359C8.33429 61.7757 9.88934 69.3537 13.0424 76.3142H106.319C109.33 69.6809 110.886 62.4793 110.88 55.1942Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M9.75977 76.3143H109.6"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 76.3143H7.2"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M112.16 76.3143H115.36"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M40.6426 76.3206L68.2419 31.472C68.4529 31.1289 68.7483 30.8456 69.0999 30.6491C69.4514 30.4526 69.8475 30.3494 70.2503 30.3494H72.3303C72.7328 30.3495 73.1287 30.4527 73.48 30.6493C73.8314 30.8458 74.1265 31.129 74.3373 31.472L101.938 76.3206H40.6426Z"
      fill={colors.purple20}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.4238 76.3207L31.3432 55.6909C31.4462 55.5102 31.5952 55.3601 31.7751 55.2556C31.9549 55.1511 32.1592 55.0961 32.3672 55.0961C32.5752 55.0961 32.7794 55.1511 32.9593 55.2556C33.1391 55.3601 33.2881 55.5102 33.3912 55.6909L45.3105 76.3207H19.4238Z"
      fill={colors.purple20}
    />
    <path
      d="M40.6426 76.3206L68.2419 31.472C68.4529 31.1289 68.7483 30.8456 69.0999 30.6491C69.4514 30.4526 69.8475 30.3494 70.2503 30.3494H72.3303C72.7328 30.3495 73.1287 30.4527 73.48 30.6493C73.8314 30.8458 74.1265 31.129 74.3373 31.472L101.938 76.3206H40.6426Z"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.4238 76.3207L31.3432 55.6909C31.4462 55.5102 31.5952 55.3601 31.7751 55.2556C31.9549 55.1511 32.1592 55.0961 32.3672 55.0961C32.5752 55.0961 32.7794 55.1511 32.9593 55.2556C33.1391 55.3601 33.2881 55.5102 33.3912 55.6909L45.3105 76.3207H19.4238Z"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32.7051 76.3206L48.0318 49.7965C48.135 49.617 48.2837 49.4679 48.463 49.3642C48.6422 49.2606 48.8456 49.206 49.0526 49.206C49.2596 49.206 49.463 49.2606 49.6422 49.3642C49.8215 49.4679 49.9702 49.617 50.0734 49.7965L65.3963 76.3206H32.7051Z"
      fill={colors.purple20}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M36.5877 19.5232C35.974 19.5265 35.3663 19.6441 34.7957 19.8701C34.4904 17.9235 33.4998 16.15 32.0025 14.8693C30.5052 13.5885 28.5997 12.8847 26.6293 12.8847C24.659 12.8847 22.7534 13.5885 21.2561 14.8693C19.7588 16.15 18.7682 17.9235 18.4629 19.8701C17.7815 19.6063 17.0503 19.4959 16.3213 19.5468C15.5923 19.5976 14.8835 19.8085 14.2453 20.1643C13.6071 20.5201 13.0551 21.0122 12.6286 21.6055C12.2021 22.1989 11.9115 22.8789 11.7776 23.5972C11.6437 24.3156 11.6697 25.0546 11.8538 25.7618C12.0378 26.4689 12.3755 27.1269 12.8426 27.6888C13.3098 28.2506 13.895 28.7027 14.5567 29.0128C15.2183 29.3229 15.9402 29.4834 16.6709 29.4829H36.5877C37.8946 29.4619 39.1409 28.928 40.0577 27.9964C40.9745 27.0648 41.4884 25.8101 41.4884 24.503C41.4884 23.196 40.9745 21.9413 40.0577 21.0096C39.1409 20.078 37.8946 19.5441 36.5877 19.5232Z"
      fill={colors.white}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinejoin="round"
    />
    <path
      d="M36.5877 19.5232C35.974 19.5265 35.3663 19.6441 34.7957 19.8701C34.4904 17.9235 33.4998 16.15 32.0025 14.8693C30.5052 13.5885 28.5997 12.8847 26.6293 12.8847C24.659 12.8847 22.7534 13.5885 21.2561 14.8693C19.7588 16.15 18.7682 17.9235 18.4629 19.8701C17.7815 19.6063 17.0503 19.4959 16.3213 19.5468C15.5923 19.5976 14.8835 19.8085 14.2453 20.1643C13.6071 20.5201 13.0551 21.0122 12.6286 21.6055C12.2021 22.1989 11.9115 22.8789 11.7776 23.5972C11.6437 24.3156 11.6697 25.0546 11.8538 25.7618C12.0378 26.4689 12.3755 27.1269 12.8426 27.6888C13.3098 28.2506 13.895 28.7027 14.5567 29.0128C15.2183 29.3229 15.9402 29.4834 16.6709 29.4829H36.5877C37.8946 29.4619 39.1409 28.928 40.0577 27.9964C40.9745 27.0648 41.4884 25.8101 41.4884 24.503C41.4884 23.196 40.9745 21.9413 40.0577 21.0096C39.1409 20.078 37.8946 19.5441 36.5877 19.5232Z"
      fill={colors.white}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinejoin="round"
    />
    <path
      d="M71.2891 30.3494V20.9197"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M71.2891 2.96515C71.289 2.62636 71.3765 2.29332 71.5432 1.99835C71.7098 1.70338 71.9499 1.45651 72.2401 1.28171C72.5303 1.10692 72.8608 1.01013 73.1995 1.00075C73.5381 0.991375 73.8735 1.06972 74.1729 1.22819L88.0481 8.58051C88.3637 8.74763 88.6277 8.99759 88.8119 9.30351C88.996 9.60943 89.0933 9.95976 89.0933 10.3168C89.0933 10.6739 88.996 11.0242 88.8119 11.3302C88.6277 11.6361 88.3637 11.886 88.0481 12.0532L71.2891 20.9197V2.96515Z"
      fill={colors.purple20}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M64.501 51.5539C64.6078 51.6962 64.7453 51.8124 64.9034 51.894C65.0615 51.9755 65.2359 52.0202 65.4137 52.0248C65.5915 52.0294 65.768 51.9936 65.9301 51.9203C66.0921 51.8469 66.2354 51.7379 66.3493 51.6013L70.3839 46.7603C70.4944 46.6274 70.6328 46.5204 70.7893 46.4469C70.9459 46.3735 71.1166 46.3355 71.2895 46.3355C71.4624 46.3355 71.6331 46.3735 71.7896 46.4469C71.9462 46.5204 72.0846 46.6274 72.1951 46.7603L76.2284 51.6013C76.3423 51.7379 76.4856 51.8469 76.6476 51.9203C76.8097 51.9936 76.9862 52.0294 77.164 52.0248C77.3418 52.0202 77.5163 51.9755 77.6743 51.894C77.8324 51.8124 77.9699 51.6962 78.0767 51.5539L82.8127 45.2422L74.3365 31.472C74.1257 31.129 73.8306 30.8458 73.4792 30.6493C73.1279 30.4527 72.7321 30.3495 72.3295 30.3494H70.2495C69.8467 30.3494 69.4507 30.4526 69.0991 30.6491C68.7476 30.8456 68.4522 31.1289 68.2412 31.472L59.7676 45.2422L64.501 51.5539Z"
      fill={colors.white}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
